import { useRef } from "react";

export default function useSwipe(onSwipe) {
  const startXRef = useRef(null);

  function onTouchStart(e) {
    if (window.innerWidth > 768) return;
    startXRef.current = e.touches[0].clientX;
  }

  function onTouchEnd(e) {
    if (startXRef.current === null || window.innerWidth > 768) {
      startXRef.current = null;
      return;
    }
    const deltaX = e.changedTouches[0].clientX - startXRef.current;
    startXRef.current = null;
    if (Math.abs(deltaX) < 40) return;
    onSwipe(deltaX < 0 ? 1 : -1);
  }

  return { onTouchStart, onTouchEnd };
}
